import { SidebarSectionType, StepTipType } from 'data/types';

type QuoteTipSectionsArgs = {
  textKeys: Record<string, string>;
  ready: boolean;
  hasSystemActions: boolean;
};

export function getQuoteTipSections({
  textKeys,
  ready,
  hasSystemActions
}: QuoteTipSectionsArgs): SidebarSectionType[] {
  const getStepText = (
    field: `tip_${number}_title` | `tip_${number}_description`,
    fallback: string
  ) => {
    return textKeys[`step_quote_${field}`] ?? fallback;
  };

  if (!ready) {
    return [];
  }

  const tips: StepTipType[] = [
    {
      targets: ['first-quote-column'],
      title: getStepText('tip_1_title', 'Choose quotes to send'),
      description: getStepText(
        'tip_1_description',
        'Each card is one complete system quote. Use the checkbox to select up to three systems to include when you send the customer their quote by email or text.'
      )
    },
    {
      targets: ['footer-next-button'],
      title: getStepText('tip_2_title', 'Send the selected quotes'),
      description: getStepText(
        'tip_2_description',
        "When you're ready, this button sends the customer every quote you've selected by email, text, or both so they can review the options side by side and buy."
      )
    },
    ...(hasSystemActions
      ? [
          {
            targets: ['quote-column-actions'],
            title: getStepText('tip_3_title', 'Or act on a single system'),
            description: getStepText(
              'tip_3_description',
              "Buy Now adds this system's equipment and accessories straight to the shopping cart for checkout, while Send this Quote Only sends just this system as its own quote."
            )
          }
        ]
      : [])
  ];

  return [
    {
      id: 'quote',
      title: 'Get Your Quote',
      description: '',
      steps: [
        {
          id: 'quote',
          title: 'Get Your Quote',
          description: '',
          status: 'incomplete',
          tips
        }
      ]
    }
  ];
}
